import { render, staticRenderFns } from "./CheckBadgeGrey.vue?vue&type=template&id=6e36de88&"
import script from "./CheckBadgeGrey.vue?vue&type=script&lang=js&"
export * from "./CheckBadgeGrey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports